import { Typography } from "@mui/material";
import React from "react";

const OfflineFallback = () => {
  return (
    <div className="flex justify-center items-center h-screen ">
      <div className="flex flex-col justify-center items-center">
        <img
          key={"store-offline"}
          className="w-[380px]"
          src={"/assets/gif/payment-loading.gif"}
          alt=""
        />
        <Typography variant="h5">
          Online orders not accepted currently!
        </Typography>
        <Typography variant="subtitle1">
          Please contact the store directly
        </Typography>
      </div>
    </div>
  );
};

export default OfflineFallback;
